import { Box, TextField, Typography } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../../common/Utils";
import styles from './InputTextField.module.scss';
import { useTranslation } from "react-i18next";
import { InputFieldProps } from "../../../../common/Interfaces";

export default function InputTextField ({id, 
                                         label, 
                                         value, 
                                         handleValueChange, 
                                         isOptional, 
                                         errorMessage, 
                                         width, 
                                         onKeyPress, 
                                         isReadOnly, 
                                        disabled}:InputFieldProps){
    const {t} = useTranslation();

    return (
        <Box sx={{width: width ?? "100%"}}>
            <Box className={styles.hotizontalContainer}>
                <TextField
                        sx={{width: width ?? "100%"}}
                        id={id}
                        name={id}
                        size="small"
                        inputProps={{
                            ...getInputProps(),
                            readOnly: isReadOnly,
                        }}
                        InputLabelProps={getInputLabelProps()}
                        label={label}
                        variant="outlined"
                        value={value}
                        onChange={handleValueChange}
                        error={!!errorMessage}
                        onKeyUp={onKeyPress}
                        disabled={disabled}
                    />

                {isOptional && (
                    <Typography className={styles.optionalText}>
                        {`(${t("OPTIONAL")})`}
                    </Typography>
                )}
            </Box>
            
            {errorMessage && (
                <Typography className={styles.errorText}>
                    {errorMessage}
                </Typography>
            )}
        </Box>
    );
}